import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IRegieSimulation } from "../../interface/regie";

export const getRegieSimulationsBySalary = async (
  salaryId: string,
  token: string,
  setSimulations: (simulations: IRegieSimulation[]) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.get(`${urlAPI}/regie/simulations/by-salary/${salaryId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setSimulations(response.data.message);
  } catch (error: any) {
    console.error(error);
    setError("Impossible de récupérer l'historique des simulations.");
    dispatch(showSnackbar("Erreur lors du chargement de l'historique des simulations.", "error"));
  }
};
